module.exports = __webpack_public_path__ + "static/doc_canuts-df41794aa247b094740da4950eb8368a.jpg";